import { IconButton } from '@sweep-io/sweep-design';
import { Close } from '@sweep-io/sweep-design/dist/icons';

export const CloseButton = ({ onClose }: { onClose: () => void }) => {
  return (
    <IconButton onClick={onClose} variant="flat">
      <Close />
    </IconButton>
  );
};
